import { useState } from 'react';
import { toast } from 'react-toastify';
import CustomFilterSelect from '../../../shared/customFilterSelect';
import './style.scss';

function EditSchoolLookupModal({ setOpenModal, onSubmit, schoolOptions = [] }) {
  const [selectedSchoolCode, setSelectedSchoolCode] = useState('');

  function handleSelectSchool(_, optionId, optionName) {
    setSelectedSchoolCode(String(optionName || optionId || '').trim());
  }

  function handleSubmit() {
    if (!selectedSchoolCode) {
      toast('Por favor selecciona el codigo de la IE', {
        type: 'warning'
      });
      return;
    }

    onSubmit(selectedSchoolCode);
  }

  return (
    <section className='main-editSchoolLookup-container'>
      <p className='title'>EDITAR PROCESO FORMATIVO</p>
      <div className='content'>
        <p className='description'>
          Selecciona el codigo de la IE que deseas editar. Debe ser el codigo de la
          tabla schools.
        </p>
        <div className='label'>
          <CustomFilterSelect
            optionsList={schoolOptions}
            placeholder='Codigo de Proceso Formativo'
            addInfo={handleSelectSchool}
            valueEdit={selectedSchoolCode}
            searchable={true}
            searchPlaceholder='Buscar codigo'
          />
        </div>
        <div className='buttons-container'>
          <button className='blue-site-button' onClick={handleSubmit} type='button'>
            BUSCAR
          </button>
          <button
            className='button-white-border-blue'
            onClick={() => setOpenModal(false)}
            type='button'
          >
            CANCELAR
          </button>
        </div>
      </div>
    </section>
  );
}

export default EditSchoolLookupModal;
